/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateUserSessionIssuerCimdClientForm,
  CreateUserSessionIssuerCimdClientForm$Outbound,
  CreateUserSessionIssuerCimdClientForm$outboundSchema,
} from "../components/createusersessionissuercimdclientform.js";

export type CreateUserSessionIssuerCimdClientSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateUserSessionIssuerCimdClientSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateUserSessionIssuerCimdClientSecurity = {
  option1?: CreateUserSessionIssuerCimdClientSecurityOption1 | undefined;
  option2?: CreateUserSessionIssuerCimdClientSecurityOption2 | undefined;
};

export type CreateUserSessionIssuerCimdClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createUserSessionIssuerCimdClientForm: CreateUserSessionIssuerCimdClientForm;
};

/** @internal */
export type CreateUserSessionIssuerCimdClientSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateUserSessionIssuerCimdClientSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateUserSessionIssuerCimdClientSecurityOption1$Outbound,
    CreateUserSessionIssuerCimdClientSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createUserSessionIssuerCimdClientSecurityOption1ToJSON(
  createUserSessionIssuerCimdClientSecurityOption1:
    CreateUserSessionIssuerCimdClientSecurityOption1,
): string {
  return JSON.stringify(
    CreateUserSessionIssuerCimdClientSecurityOption1$outboundSchema.parse(
      createUserSessionIssuerCimdClientSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateUserSessionIssuerCimdClientSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateUserSessionIssuerCimdClientSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateUserSessionIssuerCimdClientSecurityOption2$Outbound,
    CreateUserSessionIssuerCimdClientSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createUserSessionIssuerCimdClientSecurityOption2ToJSON(
  createUserSessionIssuerCimdClientSecurityOption2:
    CreateUserSessionIssuerCimdClientSecurityOption2,
): string {
  return JSON.stringify(
    CreateUserSessionIssuerCimdClientSecurityOption2$outboundSchema.parse(
      createUserSessionIssuerCimdClientSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateUserSessionIssuerCimdClientSecurity$Outbound = {
  Option1?:
    | CreateUserSessionIssuerCimdClientSecurityOption1$Outbound
    | undefined;
  Option2?:
    | CreateUserSessionIssuerCimdClientSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const CreateUserSessionIssuerCimdClientSecurity$outboundSchema:
  z.ZodMiniType<
    CreateUserSessionIssuerCimdClientSecurity$Outbound,
    CreateUserSessionIssuerCimdClientSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        CreateUserSessionIssuerCimdClientSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        CreateUserSessionIssuerCimdClientSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function createUserSessionIssuerCimdClientSecurityToJSON(
  createUserSessionIssuerCimdClientSecurity:
    CreateUserSessionIssuerCimdClientSecurity,
): string {
  return JSON.stringify(
    CreateUserSessionIssuerCimdClientSecurity$outboundSchema.parse(
      createUserSessionIssuerCimdClientSecurity,
    ),
  );
}

/** @internal */
export type CreateUserSessionIssuerCimdClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateUserSessionIssuerCimdClientForm:
    CreateUserSessionIssuerCimdClientForm$Outbound;
};

/** @internal */
export const CreateUserSessionIssuerCimdClientRequest$outboundSchema:
  z.ZodMiniType<
    CreateUserSessionIssuerCimdClientRequest$Outbound,
    CreateUserSessionIssuerCimdClientRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      createUserSessionIssuerCimdClientForm:
        CreateUserSessionIssuerCimdClientForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
        createUserSessionIssuerCimdClientForm:
          "CreateUserSessionIssuerCimdClientForm",
      });
    }),
  );

export function createUserSessionIssuerCimdClientRequestToJSON(
  createUserSessionIssuerCimdClientRequest:
    CreateUserSessionIssuerCimdClientRequest,
): string {
  return JSON.stringify(
    CreateUserSessionIssuerCimdClientRequest$outboundSchema.parse(
      createUserSessionIssuerCimdClientRequest,
    ),
  );
}
